import dayjs from 'dayjs';

import type {
  MappedRoundTripNearestSearch,
  RoundTripNearestSearchKey,
  RoundTripNearestSearchValue,
} from '../types';

const filterValidArrivalSearches = (
  searches: MappedRoundTripNearestSearch[],
  dateLimit?: string,
) => {
  if (dateLimit) {
    return searches.filter(search =>
      dayjs(search.departureDate).isSameOrAfter(dateLimit),
    );
  }
  return searches;
};

const changeSelectedDate = (
  searches: MappedRoundTripNearestSearch[],
  key: RoundTripNearestSearchKey,
  value: RoundTripNearestSearchValue,
) => {
  return searches.map(search => ({
    ...search,
    isActive: search[key] === value,
  }));
};

const findSelectedDate = (searches: MappedRoundTripNearestSearch[]) => {
  return searches.find(search => search.isActive) || searches[0];
};

export const searchesLib = {
  filterValidArrivalSearches,
  changeSelectedDate,
  findSelectedDate,
};
